export const lessonPhases = [
  {
    "range": "Lessons 1–3",
    "title": "Find control",
    "lessons": [
      "Hold, Balance and Tap",
      "Change the Grip",
      "Soft Shots Near the Net"
    ]
  },
  {
    "range": "Lessons 4–6",
    "title": "Move and start play",
    "lessons": [
      "Move, Hit and Recover",
      "Lift to a Deeper Target",
      "Start with a Short Serve"
    ]
  },
  {
    "range": "Lessons 7–9",
    "title": "Rally and choose",
    "lessons": [
      "Send the Serve Deeper",
      "Build a Cooperative Rally",
      "Find the Open Space"
    ]
  },
  {
    "range": "Lessons 10–12",
    "title": "Bring it together",
    "lessons": [
      "Practice Through Stations",
      "Play Adapted Singles",
      "Review, Play and Progress"
    ]
  }
];
